<template>
  <a-modal
    :open="visible"
    @cancel="handleConfirmClose"
    :mask-closable="false"
    :footer="null"
    width="542px"
    class="hubspot-config-modal"
    title="Configurar integración"
    centered
  >
    <!-- <a-spin :spinning="loading"> -->
      <CustomScrollbar height="calc(100vh - 300px)" class="scrollbar" auto>
        <!-- Aviso importante -->
        <a-alert type="warning" class="notice" show-icon>
          <template #message>
            <span class="notice__title">Importante:</span>
            <span class="notice__text">
              Al conectar HubSpot, se habilitó una columna de homologación con BeexCC
              en la plantilla de contactos de todas las empresas y campañas del módulo
              <router-link to="/crm/templates">Plantillas <IconExternalLink active width="13" height="12" /></router-link>. Recuerda que solo se van a
              exportar o importar las columnas homologadas.
            </span>
          </template>
        </a-alert>

        <!-- Sección dinámica (export / import) -->
        <section
          v-for="(section, typeKey) in INTEGRATION_CONFIG"
          :key="typeKey"
          class="section"
        >
          <header class="section__header">
            <h3 class="section__title">{{ section.title }}</h3>
            <a-switch
              v-model:checked="integrations[typeKey].enabled"
              @change="(event) => checkedSwitchIntegrationConfig(event, typeKey)"
              :disabled="loadingSave"
              size="small"
            />
          </header>

          <p>
            <span class="section__hint" v-html="section.hint" />
            <a
              v-if="typeKey == HubspotIntegrationType.Import"
              style="text-decoration: none"
              @click="openHubspotInfo = true"
            >
                criterios de importación de BeexCC
              <a-tooltip placement="right" v-if="typeKey == HubspotIntegrationType.Import">
                <template #title>
                  <span>
                    Solo se importarán contactos de HubSpot que tengan completas las columnas Empresa, Campaña y las homologadas marcadas como Dato requerido en las plantillas de contactos de BeexCC.
                  </span>
                </template>
                <QuestionCircleOutlined />
              </a-tooltip>
            </a>
          </p>

          <div class="block__label">Selecciona el modo:</div>

          <a-radio-group
            v-model:value="integrations[typeKey].mode"
            class="radio-col-start"
            :disabled="!integrations[typeKey].enabled || loadingSave"
          >
            <a-radio
              v-for="(modeData, modeKey) in section.modes"
              :key="modeKey"
              :value="modeKey"
            >
              <div class="radio-row__text">
                <div class="radio-row__title">{{ modeData.title }}</div>
                <div class="radio-row__desc" v-html="modeData.description"></div>

                <div v-if="integrations[typeKey].mode == modeKey && integrations[typeKey].enabled">
                  <p
                    v-if="loadingExport[typeKey]"
                    class="counter-contact"
                  >
                    Detectando contactos existentes para {{ IntegrationTypeText[typeKey] }}...
                    <LoadingOutlined />
                  </p>
                  <!-- <a-skeleton-input class="skeleton_input" style="width: 100%" active size="small" v-if="loadingExport[typeKey]" /> -->
                  <p
                    v-else
                    @click="openEventModal(typeKey)"
                    class="counter-contact"
                  >
                    <span v-if="typeKey == HubspotIntegrationType.Export">
                      Hay {{formatCount(integrations[typeKey].dataCount || 0)}} contactos existentes para {{ IntegrationTypeText[typeKey] }} a HubSpot
                    </span>
                    <span v-else>
                      Importar contactos existentes desde HubSpot
                    </span>
                    <a-tooltip placement="right">
                      <template #title >
                        <span v-if="typeKey != HubspotIntegrationType.Import">
                          Se han detectado {{formatCount(integrations[typeKey].dataCount || 0)}}  contactos creados desde tu cuenta de BeexCC con el campo “Nombres” completo, al ser el único campo obligatorio para exportar a HubSpot.
                        </span>
                        <span v-if="typeKey == HubspotIntegrationType.Import">
                          Se detectarán contactos creados en HubSpot que tengan completas las columnas Empresa, Campaña y las homologadas marcadas como Dato requerido en las plantillas de contactos de BeexCC.
                        </span>
                      </template>
                      <InfoCircleOutlined />
                    </a-tooltip>
                  </p>
                </div>
                <div 
                  v-if="integrations[typeKey].mode == modeKey && integrations[typeKey].enabled && getEventsActives(typeKey as HubspotIntegrationType)?.length > 0"
                >
                  <!-- { "id": 8, "status": 1, "scheduled": "2025-12-01T08:00:00Z", "percent": 0, "contacts_count": 0 } -->
                  <a-card
                    class="card_event" 
                    :class="getEventsActives(typeKey as HubspotIntegrationType).length > 1 && !integrations[typeKey].showAll ? 'card_event--collapsed' : ''">
                    <template #title v-if="getEventsActives(typeKey as HubspotIntegrationType).length > 1">
                      <div class="card_event-head">
                        <p>
                          <ClockCircleOutlined style="margin-right: 3px" />
                          Existen {{ getEventsActives(typeKey as HubspotIntegrationType).length }} eventos de exportación programados
                        </p>
                        <a-button type="link" style="padding: 0" @click="toggleShowAll(typeKey)">
                          {{ integrations[typeKey].showAll ? 'Ocultar' : 'Ver todos' }}
                        </a-button>
                      </div>
                    </template>
                    <div
                      v-if="getEventsActives(typeKey as HubspotIntegrationType).length == 1 || 
                        (integrations[typeKey].showAll && getEventsActives(typeKey as HubspotIntegrationType).length > 0)"
                      v-for="event, key in getEvents(typeKey as HubspotIntegrationType)"
                      :key="key"
                    >
                      <div v-if="event.state != StatusHubpspotEvent.Canceled">
                        <div class="card_event-item">
                          <p class="card_event-title">
                            Exportación de {{ formatNumber(event.contacts?.length || event.contacts_count) }} 
                            contactos de BeexCC a HubSpot.
                          </p>
                          <p>
                            {{ dayjs(event.scheduled).format("DD/MM/YYYY [a las] HH:mm") }}
                            <a-button
                              type="link"
                              :disabled="dayjs(event.scheduled).isSameOrBefore(dayjs())"
                              @click="cancelEvent(typeKey as HubspotIntegrationType, key)"
                            >
                              <DeleteOutlined style="margin-right: 3px" />
                              Eliminar
                            </a-button>
                          </p>
                        </div>
                        <a-divider class="divider_event" v-if="key > 0" />
                      </div>
                    </div>
                  </a-card>
                </div>
              </div>
            </a-radio>
          </a-radio-group>

          <a-divider v-if="typeKey === HubspotIntegrationType.Export" />
        </section>
      </CustomScrollbar>
    <!-- </a-spin> -->

    <!-- Footer -->
    <div class="footer">
      <a-button 
        @click="handleConfirmClose"
        :disabled="loadingSave"
      >
        Cancelar
      </a-button>
      <a-tooltip >
        <template #title v-if="!hasIntegrationChanges">
          <span>
            No hay nuevos cambios por guardar.
          </span>
        </template>
        <!-- :disabled="!isDirty" -->
        <a-button
          type="primary"
          :disabled="loadingSave || !hasIntegrationChanges"
          :loading="loadingSave"          
          @click="handleConfirmSave"
        >
          Guardar configuración
        </a-button>
      </a-tooltip>
    </div>
  </a-modal>

  <HubspotEventModal
    v-if="selectedIntegrationType"
    :visible="eventModalVisible"
    @update:visible="changeModalVisible"
    :type="selectedIntegrationType"
    :saving="savingEvent"
    :data-count="integrations[selectedIntegrationType].dataCount || 0"
    @save="handleEventSave"
  />

  <HubspotManualModal
    v-model:open="openHubspotInfo"
  />
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, createVNode, h } from "vue";
import IconExternalLink from "@/app/common/components/atoms/IconExternalLink.vue";
import { DeleteOutlined, InfoCircleOutlined, LoadingOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { HubspotIntegrationType, INTEGRATION_CONFIG, IntegrationHubspotCode, IntegrationHubspotTypeCode, IntegrationMode, IntegrationModeNumber, IntegrationTypeText, TransactionType } from "@/app/integrations/utils/enums";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { HubspotFunctionalityPayload, IntegrationData, StatusHubpspotEvent } from "@/@types/integrations";
import { hubspotManager } from "../../services/HubspotManager";
import httpManager, { ResponseError } from "@/app/shared/utils/httpManager";
import { IntegrationTypeSync } from "../../utils/enums";
import HubspotEventModal from "./HubspotEventModal.vue";
import { Modal, message } from "ant-design-vue";
import dayjs from "dayjs";
import { cloneDeep, isEqual } from "lodash";
import { useStore } from "vuex";
import HubspotManualModal from "./HubspotManualModal.vue";

const props = defineProps<{
  modelValue: boolean
  integration: IntegrationData | null
  hubspotConfigModalActive: boolean
}>()

// Estado inicial (mock: ajusta si recibes estos valores desde API/props)
const emit = defineEmits(['update:modelValue', 'update', 'closeVisible', 'updateEvents'])

const openHubspotInfo = ref(false);
const visible = ref(props.modelValue)
// const visible = ref(true)
watch(() => props.modelValue, async (val) => {
  console.log(val, 'visible watch')
  visible.value = val
});

watch(() => props.hubspotConfigModalActive, async (val) => {
  if (val) await getHubspotConfig();
});

const changeVisible = (val: boolean) => (emit('update:modelValue', val));

const loadingSave = ref(false);

const store = useStore();

const integrations = ref<Record<
  HubspotIntegrationType,
  { enabled: boolean; mode: IntegrationMode, dataCount: number | null, contacts: string[], showAll: boolean, events: any[] }
>>({
  [HubspotIntegrationType.Export]: {
    enabled: false,
    mode: INTEGRATION_CONFIG[HubspotIntegrationType.Export].defaultMode,
    dataCount: null,
    contacts: [],
    showAll: false,
    events: [],
  },
  [HubspotIntegrationType.Import]: {
    enabled: false,
    mode: INTEGRATION_CONFIG[HubspotIntegrationType.Import].defaultMode,
    dataCount: null,
    contacts: [],
    showAll: false,
    events: [],
  },
});
const integrationsCompare = ref<Record<
  HubspotIntegrationType,
  { enabled: boolean; mode: IntegrationMode, dataCount: number | null, contacts: string[], showAll: boolean, events: any[] }
>>();

const hasIntegrationChanges = computed(() => {
  console.log('integrations.value', integrations.value);
  console.log('integrationsCompare.value', integrationsCompare.value);
  if (!integrationsCompare.value) return false;

  return !isEqual(integrations.value, integrationsCompare.value);
});

const loadingExport = ref({
  [HubspotIntegrationType.Export]: false,
  [HubspotIntegrationType.Import]: false,
});

const isImportIntegration = (type: string) => {
  return type == HubspotIntegrationType.Import
};

const checkedSwitchIntegrationConfig = async (checked: boolean, type: string) => {
  if (checked && type == HubspotIntegrationType.Export) {
    loadingExport.value[type as HubspotIntegrationType] = true;
    const response = await hubspotManager.getContactsExportableImportable(IntegrationHubspotTypeCode[type as HubspotIntegrationType]);
    integrations.value[type as HubspotIntegrationType].dataCount = response?.[IntegrationTypeSync[type as HubspotIntegrationType] + "_count"];
    integrations.value[type as HubspotIntegrationType].contacts = response?.[IntegrationTypeSync[type as HubspotIntegrationType]];

    loadingExport.value[type as HubspotIntegrationType] = false;
  }
}

const formatNumber = (value: any) => {
  const number = Number(
    typeof value === "string"
      ? value.replace(/,/g, "")
      : value
  );

  if (Number.isNaN(number)) return "0";

  return new Intl.NumberFormat("en-US").format(number);
}

function formatCount(num: number): string {
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return num ? num.toString() : '0';
}

const handleClose = () => {
  eventModalVisible.value = false;
  changeVisible(false);
  emit('closeVisible');
}

const handleConfirmClose = () => {
  if (hasIntegrationChanges.value) {
    Modal.confirm({
      title: "¿Deseas descartar los cambios realizados?",
      content: "Recuerda que, si no guardas los cambios que realizaste, estos serán descartados.",
      icon: createVNode(QuestionCircleOutlined),
      onOk: () => handleClose(),
      centered: true,
      okText: "Sí, descartar cambios",
      cancelText: "No, seguir editando",
    });
  } else {
    handleClose();
  }
}

const toggleShowAll = (type: string) => {
  integrations.value[type as HubspotIntegrationType].showAll = !integrations.value[type as HubspotIntegrationType].showAll;
}

const eventModalVisible = ref(false);
const selectedIntegrationType = ref<HubspotIntegrationType | null>(null);
// const getEvents = (typeKey: HubspotIntegrationType) => {
//   return integrations.value[typeKey].events.filter(el => ![StatusHubpspotEvent.Finished, StatusHubpspotEvent.Canceled].includes(el.state));
// };

const getEvents = (typeKey: HubspotIntegrationType) => {
  return integrations.value[typeKey].events.filter(el => ![StatusHubpspotEvent.Finished].includes(el.state));
}

const getEventsActives = (typeKey: HubspotIntegrationType) => {
  return integrations.value[typeKey].events.filter(el => ![StatusHubpspotEvent.Finished, StatusHubpspotEvent.Canceled].includes(el.state));
}

const openEventModal = (type: HubspotIntegrationType) => {
  Modal.confirm({
    icon: createVNode(QuestionCircleOutlined),
    wrapClassName: "modal-delete",
    title: "¿Deseas " + (isImportIntegration(type) ? "importar" : "exportar") + " tus contactos existentes de HubSpot a BeexCC?",
    content: "Puedes " + (isImportIntegration(type) ? "importar" : "exportar") + " tus contactos existentes creando eventos de " + (isImportIntegration(type) ? "importarción" : "exportación") + ". Si deseas crear uno ahora, continúa. La configuración de tu integración se guardará automáticamente.",
    okText: "Si, continuar",
    cancelText: "No, seguir configurando",
    centered: true,
    onOk: async () => {
      if (hasIntegrationChanges.value)
        await handleSaveConfig();
      selectedIntegrationType.value = type;
      console.log(visible.value, 'visible change')
      eventModalVisible.value = true;
      changeVisible(false);
    },
  });
  
  // visible.value = false;
}

const changeModalVisible = (val: boolean) => {
  console.log('changeModalVisible', val);
  eventModalVisible.value = val;
  handleClose();
  // changeVisible(!eventModalVisible.value);
}

// function handleEventSave(payload: any) {
//   const { formState, type } = payload;
//   integrations.value[type as HubspotIntegrationType].events.push(formState);
//   handleSaveConfig(true);
//   // eventModalVisible.value = false;
//   // changeVisible(true);
//   // visible.value = true;
//   // Aquí puedes llamar a tu servicio backend si quieres guardar el evento
// }

const savingEvent = ref(false);

const handleEventSave = async (payload: any) => {
  try {
    savingEvent.value = true;
    const { formState, type } = payload;
    console.log(formState, 'event to save');
    const response = await hubspotManager.saveHubspotEvent({
      code: type,
      event: {
        id: formState.id,
        scheduled: formState.scheduled ?? null,
        contacts: formState.contacts ?? [],
        portfolios: formState.portfolio ?? [],
        entities: formState.entity ?? [],
      }
    });
    console.log(response, 'response')
    message.success(response.message);
    emit('update', false);
    emit('updateEvents');
    handleClose();
  } catch (error: any) {
    const messageError =
      error instanceof ResponseError ? error.getErrorMessage() : "Ha ocurrido un error";

    message.error(messageError);
  } finally {
    savingEvent.value = false;
  }
}

const buildPayload = () => {
  const functionalities: HubspotFunctionalityPayload[] = [];

  for (const type of Object.values(HubspotIntegrationType)) {
    const config = integrations.value[type];
    if (!config) continue;

    functionalities.push({
      code: IntegrationHubspotCode[type],
      mode: IntegrationModeNumber[config.mode],
      active: config.enabled,
      events: config.events.map(ev => ({
        id: ev.id,
        scheduled: ev.scheduled ?? null,
        contacts: ev.contacts ?? [],
        dataCount: ev.contacts_count ?? 0,
        portfolios: ev.portfolio ?? [],
        entities: ev.entity ?? [],
        state: ev.state,
      }))
    });
  }

  return { functionalities };
};

const handleConfirmSave = () => {
  Modal.confirm({
    title: "Estás a punto de guardar los cambios realizados, ¿deseas continuar?",
    content: h("span", [
      "Al guardar, se aplicarán todos los cambios según correspondan. Recuerda que esta acción ",
      h(
        "span",
        { style: { fontWeight: 600 } },
        "no se podrá deshacer."
      ),
    ]),
    icon: createVNode(QuestionCircleOutlined),
    onOk: () => {
      handleSaveConfig();
    },
    centered: true,
    okText: "Si, guardar cambios",
    cancelText: "No, seguir editando",
  });
};

const handleSaveConfig = async () => {
  try {
    loadingSave.value = true;
    const payload = buildPayload();
    const response = await hubspotManager.saveHubspotConfig(payload);
    console.log(response, 'response');
    // await getHubspotConfig();
    emit('updateEvents');
    emit('update', false);
    message.success(response.message);
    await store.dispatch("fetchDataUser");
    handleClose();
  } catch(error) {
    const errorMessage = error?.getErrorMessage() || "Ha ocurrido un error";
    message.error(errorMessage);
  } finally {
    loadingSave.value = false;
  }
}

const cancelEvent = (typeKey: HubspotIntegrationType, key: number) => {
  console.log(typeKey, key, 'cancelEvent');
  integrations.value[typeKey].events[key].scheduled = null
  integrations.value[typeKey].events[key].status = 2
  integrations.value[typeKey].events[key].state = StatusHubpspotEvent.Canceled
}

const loading = ref(false);

const getHubspotConfig = async () => {
  loading.value = true;
  const response = await hubspotManager.getHubspotConfig();
  if (!response?.functionalities) {
    loading.value = false;
    return;
  }

  const functionalities = response.functionalities;

  // ============================
  // 1. Crear estructura dinámica
  // ============================
  // const newIntegrations: Record<
  //   IntegrationType,
  //   {
  //     enabled: boolean;
  //     mode: IntegrationMode;
  //     dataCount: number | null;
  //     showAll: boolean;
  //     events: any[];
  //   }
  // > = Object.fromEntries(
  //   Object.values(IntegrationType).map((type) => [
  //     type,
  //     {
  //       enabled: false,
  //       mode: INTEGRATION_CONFIG[type].defaultMode,
  //       dataCount: null,
  //       showAll: false,
  //       events: [],
  //     },
  //   ])
  // ) as any;

  // ============================
  // 2. Mapear funcionalidades
  // ============================
  console.log(functionalities, 'functionalities');
  for (const f of functionalities) {
    // Buscar qué IntegrationType corresponde a este código
    const matchedType = Object.values(HubspotIntegrationType).find(
      (type) => IntegrationHubspotCode[type] === f.code
    );

    if (!matchedType) continue; // si la funcionalidad no corresponde a un tipo conocido

    integrations.value[matchedType].enabled = f.active;
    integrations.value[matchedType].mode =
      f.mode === IntegrationModeNumber.auto
        ? IntegrationMode.Auto
        : IntegrationMode.Manual;

    if (f.events && Array.isArray(f.events)) {
      integrations.value[matchedType].events = f.events.filter((ev: any) => ev.state != StatusHubpspotEvent.Finished);
    } else 
      integrations.value[matchedType].events = [];

    console.log(integrations.value, 'integrations.value functionalities');

    if (f.active) {
      await checkedSwitchIntegrationConfig(true, matchedType);
    }
  }

  // ============================
  // 3. Actualizar estado
  // ============================
  // integrations.value = newIntegrations;
  integrationsCompare.value = cloneDeep(integrations.value);
  loading.value = false;
}

// watch(visible, async (newVal) => {
//   if (newVal) {
//     await getHubspotConfig();
//   }
// });

onMounted(async () => {
  await getHubspotConfig();
})

</script>

<style lang="sass" scoped>
strong
  font-weight: 600
.hubspot-config-modal
  color: #262626E0 !important
  :deep(.ant-modal-content)
    border-radius: 14px
    color: #262626E0 !important

.modal-title
  display: flex
  align-items: center
  justify-content: space-between
  font-weight: 500
  font-size: 16px
  padding-right: 6px

  .close-btn
    font-size: 16px
    height: 28px
    width: 28px
    border-radius: 8px
    color: #000000A6

.notice
  margin-top: 22px
  margin-bottom: 16px
  border-radius: 12px

  :deep(.ant-alert-message)
    font-weight: 500

  &__title
    font-weight: 500
    font-size: 14px
    // line-height: 20px

  &__text
    margin-top: 6px
    font-weight: 400
    font-size: 14px
    // line-height: 20px

.section
  margin-top: 8px

  &__header
    display: flex
    align-items: center
    gap: 12px
    margin-bottom: 6px

  &__title
    margin: 0
    font-weight: 500
    font-size: 16px
    line-height: 22px
    color: #262626E0

  &__hint
    color: #000000A6
    margin: 0 0 10px
    font-weight: 400
    font-size: 14px
    // line-height: 20px
    vertical-align: middle

    b
      font-weight: 600

  a
    text-decoration: underline

.block
  background: rgba(0, 0, 0, 0.02)
  border: 1px solid rgba(0, 0, 0, 0.06)
  border-radius: 12px
  padding: 12px

  &__label
    font-weight: 600
    font-size: 14px
    // line-height: 20px
    margin-bottom: 10px
    color: #262626E0

.radio
  &-col
    display: grid
    gap: 10px

  &-row
    display: grid
    grid-template-columns: 22px 1fr
    gap: 10px
    align-items: start
    padding: 8px
    border-radius: 10px
    transition: background 0.2s ease

    &:hover
      background: rgba(0, 0, 0, 0.03)

    &__text
      display: grid
      gap: 2px
      color: #000000A6

    &__title
      font-weight: 400
      font-size: 14px
      line-height: 22px

    &__desc
      font-weight: 400
      font-size: 14px
      // line-height: 20px

      b
        font-weight: 600

.disabledish
  opacity: 0.6

.footer
  display: flex
  justify-content: flex-end
  gap: 10px
  margin-top: 18px

.counter-contact
  font-weight: 400
  font-size: 14px
  // line-height: 20px
  color: #1677FF
  vertical-align: middle

.radio-col-start
  display: grid
  gap: 12px

:deep(.card_event .ant-card-head)
  padding: 6px 12px
  color: $gray-8
  background-color: $gray-2
  min-height: auto
  font-size: 14px
  font-weight: 600

:deep(.card_event--collapsed .ant-card-head)
  border-radius: 8px

:deep(.ant-card-body)
  padding: 12px 0
  color: $gray-8

.card_event
  p
    margin-bottom: 0

  &-head
    display: flex
    justify-content: space-between
    align-items: center
  &-item
    padding: 0 12px

  &-title
    font-weight: 500
    

.event-summary
  display: flex
  justify-content: space-between
  align-items: center
  padding: 8px 4px
  margin-bottom: 8px

  &__text
    font-size: 14px
    color: #444

  &__toggle
    font-size: 14px
    color: #1677ff
    cursor: pointer

.divider_event
  margin: 4px 0
  // padding: 0
  // position: absolute
  // left: 0
  // top: 45px
  // margin: 10px 0

:deep(.radio-col-start .ant-radio-wrapper .ant-radio)
  align-self: start !important

:deep(.radio-col-start .ant-radio-inner)
  margin-top: 3px

.scrollbar
  padding-right: 10px

:deep(.skeleton_input .ant-skeleton-input)
  width: 100%
</style>
